module.exports = __webpack_public_path__ + "img/phone.90047030.svg";